<template>
  <span>
    {{ countryId }}
  </span>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import {RendererProps} from '@/components/stats/renderer/renderer.model';

  // TODO [feature] convert countryId to ISO, country-name / tooltip

  const props = defineProps<{
    props: RendererProps;
  }>();

  const countryId = computed(() => String(props.props.value ?? ''));
</script>
